module.exports = __webpack_public_path__ + "img/delivery-mockup.8048947f.png";